import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";

/** @deprecated No longer supported. May be replaced in future versions. */
export const ElectricityIcon = (props: SvgIconProps) => {
    return (
        <SvgIcon {...props} data-testid={"electricity-svg-icon"}>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -2 21 21" fill="currentColor">
                <path
                    d="M5.64154 12.9998V13.9998C5.64154 15.1043 6.53697 15.9998 7.64154 15.9998H12.1415"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                />
                <path
                    d="M1.13998 4.99908H2.63998H5.13998H10.14V9.06158C10.14 11.2362 8.3771 12.9991 6.20248 12.9991H5.13998C2.93085 12.9991 1.13998 11.2082 1.13998 8.99908V8.99908"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                />
                <path d="M8.14044 -0.000976562V3.99902" strokeWidth="2" stroke="currentColor" />
                <path d="M3.13931 -0.000976562V3.99902" strokeWidth="2" stroke="currentColor" />
            </svg>
        </SvgIcon>
    );
};
